const TroopStateKey: Record<number, string> = {
  1: "ready",
  2: "training",
  3: "upgrading",
  4: "inAdventure",
  5: "merged",
  6: "forSale",
  9: "notReady",
};

export const getTroopStateLabel = (
  state: number | undefined,
  translate: (key: string, options?: any) => any
) => {
  const key = TroopStateKey[state || 1] || TroopStateKey[1];
  return translate(`barracks:states.${key}`);
};
